import styled from '@emotion/styled'
import { handleChipColor } from './utils'

export const CohortLearningSection = ({ cohortLearnings }: any) => (
  <>
    <StatContainer>
      ACCESSED RESOURCES:
      <StyledChip
        color={handleChipColor(
          cohortLearnings?.accessedResourcesPercentUp,
          cohortLearnings?.accessedResourcesPercentDown
        )}
      >
        {cohortLearnings?.accessedResourcesPercent}
      </StyledChip>
    </StatContainer>
    <StatContainer>
      DOWNLOADS:
      <StyledChip
        color={handleChipColor(
          cohortLearnings?.downloadsPercentUp,
          cohortLearnings?.downloadsPercentDown
        )}
      >
        {cohortLearnings?.downloadsPercent}
      </StyledChip>
    </StatContainer>
    <StatContainer>
      COURSES COMPLETED:
      <StyledChip
        color={handleChipColor(
          cohortLearnings?.completedCoursesPercentUp,
          cohortLearnings?.completedCoursesPercentDown
        )}
      >
        {cohortLearnings?.completedCoursesPercent}
      </StyledChip>
    </StatContainer>
    <StatContainer>
      COURSES STARTED:
      <StyledChip
        color={handleChipColor(
          cohortLearnings?.coursesStartedPercentUp,
          cohortLearnings?.coursesStartedPercentDown
        )}
      >
        {cohortLearnings?.coursesStartedPercent}
      </StyledChip>
    </StatContainer>
    {cohortLearnings?.academySummaryString}
  </>
)

const StyledChip = styled.div<{ color: string }>`
  height: 24px;
  padding: 2px;
  margin: 2px;
  background-color: ${(props) => props.color};
  color: black;
  border-radius: 4px;
  min-width: 35px;
`

const StatContainer = styled.div`
  display: flex;
  justify-content: space-between;
`
